import { render, staticRenderFns } from "./SchoolAccordion.vue?vue&type=template&id=3ee4b5d1&scoped=true&"
import script from "./SchoolAccordion.vue?vue&type=script&lang=js&"
export * from "./SchoolAccordion.vue?vue&type=script&lang=js&"
import style0 from "./SchoolAccordion.vue?vue&type=style&index=0&id=3ee4b5d1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ee4b5d1",
  null
  
)

export default component.exports